import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const container = css`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${pxToRem(spacing.md)};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-template-columns: repeat(2, 1fr);
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-template-columns: repeat(3, 1fr);
    `,
  )}
`;

export const attributeItem = css`
  min-width: 0;
  ${responsiveText.BODY.SM};
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};

  b {
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  }
`;
